<template>
    <!-- 个人首页 有解锁的专家-->
    <div class="pad-2 wid-12" v-show="!$route.meta.showFather">
        <div class="box-shadow pt-1 flex-1 jus-bet mb-16" v-show="this.$route.path !== '/personal/unlockedExperts'">
            <div></div>
            <div>
                <img src="../../assets/myself/touxiang.png" alt="" style="width: 100px;height: 100px;">
                <p class="record-1" style="padding: 10px 0;">王黎明</p>
                <img src="../../assets/myself/wodevip.png" alt="" @click="myVIP">
            </div>
            <div></div>
        </div>
        <collect></collect>
        </div>
</template>

<script>
    import Breadcrumb from '@/views/Breadcrumb.vue';
    import footers from '@/views/footers.vue';
    import collect from '@/components/collect.vue';
    export default {
        components: {
            Breadcrumb,
            footers,collect
        },
        data() {
            return {
                provice: ['全部', '北京', '北京', '北京', '北京', '北京', '北京', '北京', '北京', '北京', '北京', '北京', '北京', '北京', '北京',
                    '北京', '北京', '北京', '北京', '北京', '北京', '北京',
                ],
                school: ['全部', '小学', '初中', '高中', '大学', ],
                officl: ['全部', '数学', '数学', '高中', '大学'],
                goodat: ['全部', '领域二', '领域二', '领域二', ],
                money: ['全部', '1000~2000元', '2000~3000元'],
                isNo: ['全部', '公益', '非公益'],
                expertList: [{
                        hed_img: require("../../assets/home/Rectangle 4.png"),
                        img: require("../../assets/expert/nan.png"),
                        name: '金子谦',
                        job: '北京师范大学第二附属中学',
                        gooat: '数学教学；课堂教学；教师专业成长',
                        jianjie: '中国当代著名教育家，曾任北大附中副校长、党委副书记、北医附中党总支书记，北京市数学特级教师，全国优秀教师，享受国务院特殊津贴专家，高中《国家数学课程标准》的研制核心组成员，曾获“北京市十大杰出青年”、“全国优秀教师”、“苏步青数学教育奖”一等奖、胡楚南优秀教学成...'
                    },
                    {
                        hed_img: require("../../assets/home/Rectangle 4.png"),
                        img: require("../../assets/expert/nan.png"),
                        name: '金子谦',
                        job: '北京师范大学第二附属中学',
                        gooat: '数学教学；课堂教学；教师专业成长',
                        jianjie: '中国当代著名教育家，曾任北大附中副校长、党委副书记、北医附中党总支书记，北京市数学特级教师，全国优秀教师，享受国务院特殊津贴专家，高中《国家数学课程标准》的研制核心组成员，曾获“北京市十大杰出青年”、“全国优秀教师”、“苏步青数学教育奖”一等奖、胡楚南优秀教学成...'
                    },
                    {
                        hed_img: require("../../assets/home/Rectangle 4.png"),
                        img: require("../../assets/expert/nan.png"),
                        name: '金子谦',
                        job: '北京师范大学第二附属中学',
                        gooat: '数学教学；课堂教学；教师专业成长',
                        jianjie: '中国当代著名教育家，曾任北大附中副校长、党委副书记、北医附中党总支书记，北京市数学特级教师，全国优秀教师，享受国务院特殊津贴专家，高中《国家数学课程标准》的研制核心组成员，曾获“北京市十大杰出青年”、“全国优秀教师”、“苏步青数学教育奖”一等奖、胡楚南优秀教学成...'
                    },
                    {
                        hed_img: require("../../assets/home/Rectangle 4.png"),
                        img: require("../../assets/expert/nan.png"),
                        name: '金子谦',
                        job: '北京师范大学第二附属中学',
                        gooat: '数学教学；课堂教学；教师专业成长',
                        jianjie: '中国当代著名教育家，曾任北大附中副校长、党委副书记、北医附中党总支书记，北京市数学特级教师，全国优秀教师，享受国务院特殊津贴专家，高中《国家数学课程标准》的研制核心组成员，曾获“北京市十大杰出青年”、“全国优秀教师”、“苏步青数学教育奖”一等奖、胡楚南优秀教学成...'
                    }

                ],
                currentPage4: 4,
                input: '',
                value: '',
                shaiSow: false,
            }
        },
        created() {

        },
        mounted() {
            // console.log(this.$route.fullPath,'地址栏')
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            hancleClick() {},
            // 专家详情
            expertDetail() {
                this.$router.push('/expert/expertDetail')
            },
            myVIP() {
                this.$router.push('/personal/member/index')
            },
            clect() {
                this.shaiSow = true;
            },
            upShow() {
                this.shaiSow = false;
            }

        }
    }
</script>


<style scoped>
    .box-shadow {
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);

        border-radius: 8px 8px 8px 8px;
    }

    .pt-1 {
        padding: 32px 0;
        text-align: center;
    }

    .pad-1 {
        padding: 32px 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    .left-icon {
        width: 6px;
        height: 20px;
        background: #3377FF;
        border-radius: 18px;
        margin-right: 10px;
    }

    .record {
        font-size: 14px;
        color: #333333;
        line-height: 21px;
        margin-right: 8px;
    }

    .record-1 {
        font-size: 20px;
        color: #222222;
    }

    .mb-24 {
        margin-bottom: 24px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .vipp div p:first-child,
    .tishi {
        color: #666666;
        font-size: 14px;
        margin-bottom: 8px;
    }

    .vipp div p:last-child,
    .hui {
        color: #222222;
        font-size: 16px;
    }

    .unPhoto {
        /* width: 100%;height: auto; */
    }

    .tishi {
        color: #FF4E33 !important;
    }

    .name-1 {
        font-size: 20px;
        padding-right: 9px;
    }

    .name-2 {
        color: #999999;
        font-size: 14px;
        white-space: nowrap;
        padding-right: 8px;
    }

    .name-3 {
        font-size: 14px;
        font-weight: normal;
    }

    /deep/.el-pagination {
        text-align: center;
    }

    .col-22 {
        color: #222222;

    }

    .hed-img {
        width: 160px;
        height: 160px;
        padding-right: 16px;
    }

    .sex-img {
        width: 14px;
        height: 14px;
    }

    .online {
        font-size: 14px;
        color: #3377FF;
        padding: 8px 16px;
        background: #F0F5FF;
        white-space: nowrap;
        border-radius: 35px 35px 35px 35px;
    }

    .mb-8 {
        margin-bottom: 8px;
    }

    .experts p {
        font-size: 20px;
        color: #222222;
        padding-left: 10px;
    }

    .check {
        /* width: 100%; */
        /* height: 352px; */
        background: #FAFAFA;
        border-radius: 4px 4px 4px 4px;
        color: #222222;
    }

    .check-1 {
        display: flex;
        /* align-items: center; */
        margin-bottom: 16px;
    }

    .check-1 p {
        padding: 4px 12px;
        font-size: 14px;
    }

    .check-1-p {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .check-1-p p:first-child {
        color: #3377FF;
        background: #F0F5FF;
        border-radius: 8px 8px 8px 8px;
    }

    .check-p {
        margin-right: 24px;
        min-width: 74px;
    }

    .shouqi {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        cursor: pointer;
        color: #666666;
    }

    .align-1 {
        align-items: center;
    }

    .pad-16 {
        padding: 16px;
    }

    .shouqi span {
        padding-right: 8px;
    }
</style>
